import { useEffect, useState, useRef } from "react";
import { Avatar, Tooltip } from "antd";
import { avatarUrl } from "~/utils/app";
import { userUrl } from "~/utils/route";

const UserAvatar = ({ user, size }) => {
  const handleClick = () => window.open(userUrl(user), "_blank");

  return (
    <Tooltip title={user.nickname} placement="top">
      <Avatar
        alt="头像"
        size={size}
        style={{ border: "2px solid #FFCB6C" }}
        src={avatarUrl(user, 64)}
        onClick={handleClick}
      />
    </Tooltip>
  );
}

const UserAvatarGroup = ({ users, size = 32 }) => {
  const [maxCount, setMaxCount] = useState(8);
  const containerRef = useRef(null);

  useEffect(() => {
    // 根据容器宽度，自适应设置 Avatar.Group 的最大数量，使其自动充满整行
    const updateMaxCount = () => {
      if (containerRef.current) {
        const containerWidth = containerRef.current.offsetWidth;
        const gap = -8;
        // 第一个头像没有 left gap, 减去它的宽度
        const maxAvatars = Math.floor((containerWidth - size) / (size + gap));
        setMaxCount(maxAvatars);
      }
    };

    updateMaxCount();

    window.addEventListener('resize', updateMaxCount);
    return () => {
      window.removeEventListener('resize', updateMaxCount);
    };
  }, []);

  return (
    <div ref={containerRef}>
      <Avatar.Group maxCount={maxCount} maxStyle={{ color: '#f56a00', backgroundColor: '#fde3cf', fontSize: '10px' }}>
        {users.map(user => <UserAvatar key={user.id} user={user} size={size} />)}
      </Avatar.Group>
    </div>
  );
}

export default UserAvatarGroup;
